import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { FORMAT_TEXT_COMMAND } from 'lexical';
import { BoldAction } from '../../molecules/bold-action';
import { useToolbarState } from '../../providers/toolbar-provider';

export const Bold = () => {
  const [editor] = useLexicalComposerContext();
  const { isBold } = useToolbarState(['isBold']);

  const onBoldSelect = useCallback(() => {
    editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
  }, [editor]);

  return <BoldAction onClick={onBoldSelect} isActive={isBold} aria-label='Format Bold' />;
};

Bold.displayName = 'Bold';
